module.exports = __webpack_public_path__ + "static/index/img/baikal-808.60a5e337.jpg";